export default __webpack_public_path__ + "static/media/Ginevra Grisotto.90baf94d.jpg";